import { EnumProductSort } from "../enums/EnumProductSort";
import { EnumSortDirection } from "../enums/EnumSortDirection";
import { JsonProduct } from "../json-data-types/JsonProduct";
import { JsonProductList } from "../json-data-types/JsonProductList";
import { RequestMaker } from "./RequestMaker";

const filename = 'ServerProductLists'

export module ServerProductLists{
    export async function getOneAsync(p:{ 
        productType:string
        sortBy?: EnumProductSort
        sortDirection?: EnumSortDirection
        pageNumber:number
        count:number
        listId:string
        getProductsAlso:boolean
    }){
        // if(!p.listId)
        const result = await RequestMaker.sendWebsocketJsonRequestAsync<{list:JsonProductList, products:JsonProduct[]}>({
            query:'productlist', 
            params: p
        }, filename)
        return result
    }
}